import React, { useCallback, useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const NAMES = ['Sarah M.', 'James T.', 'Emily R.', 'Michael B.', 'Jessica L.', 'David K.', 'Amanda W.', 'Chris P.', 'Laura H.', 'Robert S.', 'Ashley G.', 'Daniel F.', 'Megan C.', 'Brian N.', 'Stephanie A.', 'Kevin D.', 'Rachel V.', 'Jason E.', 'Nicole Z.', 'Andrew J.', 'Maria L.', 'Thomas W.', 'Jennifer Q.', 'Mark R.', 'Lisa P.', 'Steven H.', 'Karen B.', 'Paul M.', 'Sandra T.', 'George F.'];
const CITIES = ['Houston, TX', 'Phoenix, AZ', 'Nashville, TN', 'Orlando, FL', 'Portland, OR', 'Denver, CO', 'Atlanta, GA', 'Chicago, IL', 'Dallas, TX', 'San Diego, CA', 'Tampa, FL', 'Charlotte, NC', 'Austin, TX', 'Columbus, OH', 'Indianapolis, IN', 'Seattle, WA', 'Jacksonville, FL', 'Raleigh, NC', 'Salt Lake City, UT', 'Boise, ID', 'Tucson, AZ', 'Memphis, TN', 'Louisville, KY', 'Oklahoma City, OK', 'Richmond, VA', 'Omaha, NE', 'Knoxville, TN', 'Spokane, WA'];
const PRODUCT = {
  title: '72-Hour Emergency Binder + 3 Bonuses',
  price: '$6.39',
  thumbnail: 'https://cdn.magicpatterns.com/uploads/8ubZM7iCuRTeiHqk2DCMyn/Prod._2.png'
};
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval() {
  return (Math.random() * 7 + 8) * 1000; // 8–15 seconds
}
interface Notification {
  id: number;
  name: string;
  city: string;
}
export function RecentPurchaseToast() {
  const [current, setCurrent] = useState<Notification | null>(null);
  const recentNames = useRef<string[]>([]);
  const idCounter = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const prefersReducedMotion = useRef(false);
  useEffect(() => {
    prefersReducedMotion.current = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }, []);
  const pickName = useCallback(() => {
    const available = NAMES.filter(n => !recentNames.current.includes(n));
    const pool = available.length > 0 ? available : NAMES;
    const name = getRandomItem(pool);
    recentNames.current.push(name);
    if (recentNames.current.length > 10) {
      recentNames.current.shift();
    }
    return name;
  }, []);
  const showNotification = useCallback(() => {
    const id = ++idCounter.current;
    const name = pickName();
    const city = getRandomItem(CITIES);
    setCurrent({
      id,
      name,
      city
    });
    // Hide after 4 seconds
    setTimeout(() => {
      setCurrent(null);
    }, 4000);
  }, [pickName]);
  const scheduleNext = useCallback(() => {
    timerRef.current = setTimeout(() => {
      showNotification();
      scheduleNext();
    }, getRandomInterval());
  }, [showNotification]);
  useEffect(() => {
    // First notification after 3 seconds
    const initialTimer = setTimeout(() => {
      showNotification();
      scheduleNext();
    }, 3000);
    return () => {
      clearTimeout(initialTimer);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [showNotification, scheduleNext]);
  const motionVariants = prefersReducedMotion.current ? {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 40
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 40
    }
  };
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[90] pointer-events-none" data-id="element-167">
      <AnimatePresence mode="wait" data-id="element-168">
        {current && <motion.div key={current.id} initial={motionVariants.initial} animate={motionVariants.animate} exit={motionVariants.exit} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-white rounded-lg shadow-xl border border-gray-200 px-4 py-3 flex items-center gap-3 max-w-sm w-max" data-id="element-169">
            <img src={PRODUCT.thumbnail} alt={PRODUCT.title} className="w-12 h-12 object-contain rounded flex-shrink-0" data-id="element-170" />
            <div className="min-w-0" data-id="element-171">
              <p className="font-heading text-sm text-navy font-bold leading-tight" data-id="element-172">
                {current.name}{' '}
                <span className="font-normal text-gray-500" data-id="element-173">in</span>{' '}
                {current.city}
              </p>
              <p className="font-body text-xs text-gray-600 mt-0.5" data-id="element-174">
                just purchased{' '}
                <span className="font-bold text-navy" data-id="element-175">{PRODUCT.title}</span>
                {' — '}
                <span className="font-bold text-cta-green" data-id="element-176">
                  {PRODUCT.price}
                </span>
              </p>
            </div>
            <div className="w-2 h-2 rounded-full bg-cta-green flex-shrink-0 animate-pulse" data-id="element-177"></div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}